export default __webpack_public_path__ + "static/media/payment_method_icon.cce584d6.svg";